<template>
  <div>
    <section class="section is-main-section">
      <card-component title="Client Form" icon="raspberry-pi" has-back>
        <form @submit.prevent="submit">
          <b-field label="Client Info" horizontal>
            <b-input placeholder="Name" v-model="form.name" />
          </b-field>
          <b-field horizontal>
            <b-input placeholder="Email" v-model="form.email" />
          </b-field>
          <b-field horizontal>
            <b-input placeholder="Address" v-model="form.address" />
          </b-field>
          <b-field horizontal>
            <b-input placeholder="Phone Number" v-model="form.phone_number" />
          </b-field>
          <hr />
          <b-field
            v-if="projects"
            custom-class="is-normal"
            label="Projects"
            horizontal
          >
            <multiselect
              v-model="form.projects"
              :options="projects"
              multiple
              label="name"
              track-by="name"
            />
          </b-field>
          <hr />
          <b-field horizontal>
            <b-button
              type="is-primary"
              :loading="isLoading"
              native-type="submit"
            >
              Submit
            </b-button>
          </b-field>
        </form>
      </card-component>
    </section>
  </div>
</template>

<script>
import { create as createClient } from '@/api/client'
import { read as readProject } from '@/api/project'

import Multiselect from 'vue-multiselect'

export default {
  name: 'CreateClient',
  components: { Multiselect },
  data() {
    return {
      isLoading: false,
      projects: [],
      form: {
        name: null,
        email: null,
        address: null,
        phone_number: null,
        projects: [],
      }
    }
  },
  created() {
    readProject()
      .then(res => {
        this.projects = res.data.projects
      })
  },
  computed: {
    isFormValid() {
      // TODO : add validation
      return true
    }
  },
  methods: {
    submit() {
      this.isLoading = true

      if (!this.isFormValid) {
        this.isLoading = false
        return
      }

      createClient(this.form)
        .then(() => {
          this.$router.back()
        })
        .catch(err => {
          this.$buefy.toast.open({
            message: `Error: ${err.message}`,
            type: 'is-danger',
            queue: false
          })
        })
        .finally(() => { this.isLoading = false })
    }
  }
}
</script>
